import Swiper, { Autoplay, Navigation, Pagination, EffectFade, EffectCoverflow, EffectCreative, EffectCube, EffectCards, EffectFlip, Keyboard } from 'swiper';

document.addEventListener('DOMContentLoaded', function() {

    // var logoswiper = new Swiper(".sliderthis", {
    //   modules: [Autoplay, Navigation, Pagination],
    //   slidesPerView: 3,
    //   spaceBetween: 30,
    //   autoplay: {delay: 3000},
    //   loop: true,
    //   pagination: {
    //     el: ".swiper-pagination",
    //     type: 'bullets',
    //     clickable: true,
    //   },

    //   breakpoints: {
    //         // when window width is >= 320px
    //         // 500: {
    //         //   slidesPerView: 3,
    //         // },
    //         900: {
    //           slidesPerView: 5,
    //         },
    //     }
    // });


    document.querySelectorAll('.swiper-slider').forEach(function(slider) {

        let defaults = {
            modules: [Autoplay, Navigation, Pagination, EffectFade, EffectCoverflow, EffectCreative, EffectCube, EffectCards, EffectFlip],
            effect: 'slide',
            speed: 800,
            // autoplay: {delay: 5000},
            autoplay: false,
            keyboard: true,
            loop: true,
            observer: true,
            observeParents: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            fadeEffect: {
                crossFade: true
            },
        };

        let options = Object.assign({}, defaults, JSON.parse(slider.dataset.options || '{}'));

        new Swiper(slider, options);
    });

    document.querySelectorAll('.swiper-slider-testimonial').forEach(function(slider) {

        var options = {
            modules:        [Navigation, EffectCards, Keyboard],
            effect:         'cards',
            cardsEffect: {
                perSlideOffset: -4,
                perSlideRotate: 8,
            },
            autoplay:       false,
            loop:           false,
            rewind:         true,
            observer:       true,
            observeParents: true,
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            // on: {
                // Lazy load fix for loop
            //     afterInit: (slider) => {
            //         new LazyLoad({
            //             container: slider.el,
            //             cancel_on_exit: false
            //         });
            //     },
            // },
        };

        var row = slider.closest('.swiper-slider-testimonial-container');
        var content = (row && row.querySelector('.swiper-slider-testimonial-content')) || null;

        if (content) {
            var contentSlider = new Swiper(content, {
                modules:        [Navigation],
                effect:         'slide',
                autoplay:       false,
                loop:           false,
                rewind:         true,
                observer:       true,
                observeParents: true,
                clickable:      true,
                navigation: {
                    nextEl: '.testimonial-button-next',
                    prevEl: '.testimonial-button-prev',
                },
            });

            // var options = Object.assign(options, {
            //     content: {
            //       swiper: contentSlider
            //     }
            // });
        }

        var mainSlider = new Swiper(slider, options);

        if (content) {
            mainSlider.on("slideChange", (slider) => {
                contentSlider.slideTo(mainSlider.activeIndex);
            });
            contentSlider.on("slideChange", (slider) => {
                mainSlider.slideTo(contentSlider.activeIndex);
            });
        }

    });
});
